import React, { useState, useEffect } from "react";
import "../css/pages.css";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Basefooter from "./Basefooter";
import Baseheader from "./Baseheader";
import {
  createaDairy,
  getalldates,
  getdateDetails,
  updatedairy,
} from "./helper/pages";
import { isAutheticated } from "../auth/helper";

const Pages = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();
  today = yyyy + "-" + mm + "-" + dd;
  const [values, setValues] = useState({
    title: "",
    date: today,
    content: "Enter Your Diary Here ",
    error: "",
    loading: false,
  });
  const [dates, setDates] = useState({
    errordates: "",
    alldate: [],
    indexwith: [],
    titles: [],
    contents: [],
    loadingdates: true,
  });
  const {
    alldate,
    indexwith,
    titles,
    contents,
    errordates,
    loadingdates,
  } = dates;
  const { date, title, content, error, loading } = values;
  const { user, token } = isAutheticated();
  const handleChange = (name) => (event) => {
    setValues({ ...values, error: false, [name]: event.target.value });
  };

  let array = [],
    array2 = [],
    array3 = [],
    array4 = [];

  const onSubmit = (event) => {
    event.preventDefault();
    setValues({ ...values, error: "", loading: true });
    let flag = true;
    for (let index = 0; index < alldate.length; index++) {
      if (alldate[index] === date) {
        flag = false;
        break;
      }
    }
    if (flag) {
      createaDairy(user._id, token, values).then((data) => {
        if (data.error) {
          setValues({ ...values, error: data.error });
        } else {
          setValues({
            ...values,
            loading: false,
          });
        }
      });
    } else {
      for (let index = 0; index < alldate.length; index++) {
        if (alldate[index] === date) {
          updatedairy(indexwith[index], token, values).then((data) => {
            if (data.error) {
              setValues({ ...values, error: data.error });
            } else {
              setValues({
                ...values,
                loading: false,
              });
            }
          });
          break;
        }
      }
    }
  };
  const onview = (date, title, content) => {
    setValues({
      ...values,
      title: title,
      date: date,
      content: content,
      error: "",
    });
  };

  const preloadDates = () => {
    getalldates(user._id, token).then((data) => {
      if (data.error) {
        setDates({ ...dates, errordates: data.error });
      } else {
        for (let index = 0; index < data.dates.length; index++) {
          getdateDetails(data.dates[index], token).then((finaldata) => {
            if (finaldata.error) {
              setDates({ ...dates, errordates: finaldata.error });
            } else {
              array.push(finaldata.date);
              array2.push(finaldata.title);
              array3.push(finaldata._id);
              array4.push(finaldata.content);
              setDates({
                ...dates,
                alldate: array,
                indexwith: array3,
                titles: array2,
                contents: array4,
                loadingdates: false,
              });
            }
          });
        }
      }
    });
  };

  useEffect(() => {
    preloadDates();
  }, []);
  return (
    <div className="maincontent">
      <Baseheader />
      {!loading && (
        <div className="contentform">
          <div className="pagescontent">
            <div>
              <h1>Dates Section :-</h1>
            </div>
            <div>
              <h1>{loadingdates && "loading"}</h1>
              {!loadingdates &&
                alldate.map((date, index) => {
                  return (
                    <div className={indexwith[index]}>
                      <div className="datestitles">
                        Title :- {titles[index]}
                      </div>
                      <div className="datesdate">Date :- {date}</div>
                      <button
                        className="viewbtn Submitbtn"
                        onClick={() =>
                          onview(date, titles[index], contents[index])
                        }
                      >
                        View
                      </button>
                      <br />
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="writingpage">
            <div className="headingcontent">
              <label htmlFor="" className="titlelabel">
                Title :-
              </label>
              <input
                type="text"
                className="titleinput"
                onChange={handleChange("title")}
                value={title}
              />
              <label htmlFor="" className="datelabel">
                Date :-
              </label>
              <input
                type="date"
                className="dateinput"
                onChange={handleChange("date")}
                value={date}
                readOnly
              />
            </div>
            <CKEditor
              editor={ClassicEditor}
              data={content}
              onChange={(event, editor) => {
                const data = editor.getData();
                setValues({ ...values, error: false, content: data });
              }}
            />
            <div className="Submit">
              <button className="Submitbtn" onClick={onSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {loading && (
        <div className="processing">
          <h1>Processing</h1>
        </div>
      )}
      <Basefooter />
    </div>
  );
};
export default Pages;
